<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm4>
                <div class="form-group dropbox" v-if="!product.imageUrl">
                  <button
                    v-if="product.imageUrl"
                    style="float: right"
                    @click="removeImage"
                    class="close"
                    type="button"
                  >
                    <v-icon color="red">cancel</v-icon>
                  </button>
                  <input
                    type="file"
                    @change="onFileChanged"
                    class="input-file"
                  />
                  <p v-if="!product.imageUrl">
                    Drag your file(s) here to begin
                    <br />or click to browse
                  </p>
                </div>
                <div v-if="product.imageUrl">
                  <img :src="product.imageUrl" width="300px" height="150px" />
                  <button
                    style="float: right"
                    @click="removeImage"
                    class="close"
                    type="button"
                  >
                    <v-icon color="red">cancel</v-icon>
                  </button>
                </div>
              </v-flex>
              <v-flex sm8></v-flex>
              <v-flex sm12 v-if="responseError">
                <span class="red--text">* {{ responseError }}</span>
              </v-flex>
              <v-flex sm6>
                <v-layout row wrap>
                  <v-flex sm12>
                    <v-text-field
                      name="name"
                      label="Product Name"
                      v-model="product.name"
                      type="text"
                      :rules="rules.productNameRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm12>
                    <v-text-field
                      name="name"
                      label="Product Name2"
                      v-model="product.name2"
                      type="text"
                      :rules="rules.productName2Rules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm12>
                    <v-text-field
                      name="name"
                      label="Product Code"
                      v-model="product.code"
                      type="text"
                      :rules="rules.codeRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm12>
                    <v-autocomplete
                      v-model="product.brandName"
                      :items="brandList"
                      :hide-no-data="true"
                      color="blue-grey lighten-2"
                      label="Choose Brand..."
                      item-text="name"
                      item-value="name"
                      menu-props="auto"
                      :rules="rules.brandRules"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex sm12>
                    <v-autocomplete
                      v-model="product.categoryName"
                      :items="categoryList"
                      :hide-no-data="true"
                      color="blue-grey lighten-2"
                      label="Choose Category..."
                      item-text="name"
                      item-value="name"
                      menu-props="auto"
                      :rules="rules.categoryRules"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex sm12>
                    <v-select
                      :items="productTypeList"
                      label="Product Type"
                      item-text="label"
                      item-value="value"
                      v-model="product.productType"
                    ></v-select>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm6>
                <v-layout row wrap>
                  <v-flex sm12>
                    <v-autocomplete
                      v-model="product.productGroupName"
                      :items="productGroupList"
                      :hide-no-data="true"
                      color="blue-grey lighten-2"
                      label="Choose Product Group..."
                      item-text="name"
                      item-value="name"
                      menu-props="auto"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex sm12>
                    <v-text-field
                      name="description"
                      label="Product Description"
                      v-model="product.description"
                      type="text"
                      :rules="rules.descriptionRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm12>
                    <v-text-field
                      name="minQty"
                      label="Min Qty"
                      v-model="product.minQty"
                      type="text"
                      min="0"
                      oninput="this.value = Math.abs(this.value)"
                      :rules="rules.qtyRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm12>
                    <v-text-field
                      name="maxQty"
                      label="Max Qty"
                      v-model="product.maxQty"
                      type="text"
                      min="0"
                      oninput="this.value = Math.abs(this.value)"
                      :rules="rules.qtyRules"
                    ></v-text-field>
                  </v-flex>
                  <v-flex sm12>
                    <v-text-field
                      name="reorderQty"
                      label="Reorder Qty"
                      v-model="product.reorderQty"
                      type="text"
                      min="0"
                      oninput="this.value = Math.abs(this.value)"
                      :rules="rules.qtyRules"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex sm6 v-if="product.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Created Date"
                    type="text"
                    prepend-icon="event"
                    v-model="createdDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="createdDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="product.id">
                <v-text-field
                  name="createdBy"
                  label="Created By"
                  v-model="product.createdBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="product.id">
                <v-menu
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  :disabled="true"
                >
                  <v-text-field
                    slot="activator"
                    label="Updated Date"
                    type="text"
                    prepend-icon="event"
                    v-model="updatedDate"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="updatedDate"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex sm6 v-if="product.id">
                <v-text-field
                  name="updateBy"
                  label="Updated By"
                  v-model="product.updatedBy"
                  type="text"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex sm6 v-if="product.id">
                <v-switch
                  :label="`Status is ${statusFlag ? 'Active' : 'Inactive'}`"
                  :value="statusFlag"
                  v-model="statusFlag"
                ></v-switch>
              </v-flex>
              <v-flex>
                <v-layout row wrap>
                  <v-btn color="success" @click="addProductUnit()">
                    Add Unit
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>

                <v-card
                  v-for="(productUnit, index) in product.productUnits"
                  :key="index"
                  class="mb-2 mt-2"
                >
                  <v-layout row wrap class="light--text ml-2">
                    <v-flex xs1>Factor</v-flex>
                    <v-flex xs2>Unit</v-flex>
                    <v-flex xs1
                      ><v-layout row wrap
                        ><v-flex xs6>Basic</v-flex
                        ><v-flex xs6>Pur chase</v-flex></v-layout
                      ></v-flex
                    >
                    <v-flex xs1
                      ><v-layout row wrap
                        ><v-flex xs6>Sale</v-flex
                        ><v-flex xs6>Basic Price</v-flex></v-layout
                      ></v-flex
                    >
                    <v-flex xs2>Barcode</v-flex>
                    <v-flex xs2>Unit Cost</v-flex>
                    <v-flex xs2>Unit Cost(%)</v-flex>
                    <v-flex xs1>Action</v-flex>
                  </v-layout>
                  <v-layout row class="ml-2">
                    <v-flex xs1 v-if="productUnit.factor === 1">
                      <v-text-field
                        v-model="productUnit.factor"
                        type="number"
                        min="0"
                        oninput="this.value = Math.abs(this.value)"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1 v-else>
                      <v-text-field
                        v-model="productUnit.factor"
                        type="number"
                        min="0"
                        :rules="rules.factorRules"
                        :readonly="!!productUnit.id"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                      <v-autocomplete
                        v-model="productUnit.unitName"
                        :items="activeUnitList"
                        :hide-no-data="true"
                        color="blue-grey lighten-2"
                        item-text="name"
                        item-value="name"
                        menu-props="auto"
                        label="Select"
                        :rules="rules.unitRules"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs1 v-if="productUnit.basicUnit">
                      <v-layout row wrap>
                        <v-flex xs6
                          ><v-checkbox
                            v-model="productUnit.basicUnit"
                            readonly
                          ></v-checkbox
                        ></v-flex>
                        <v-flex xs6
                          ><v-checkbox
                            v-model="productUnit.purchaseUnit"
                          ></v-checkbox
                        ></v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs1 v-else>
                      <v-layout row wrap>
                        <v-flex xs6></v-flex>
                        <v-flex xs6
                          ><v-checkbox
                            v-model="productUnit.purchaseUnit"
                          ></v-checkbox
                        ></v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs1>
                      <v-layout row wrap>
                        <v-flex xs6
                          ><v-checkbox
                            v-model="productUnit.saleUnit"
                          ></v-checkbox
                        ></v-flex>
                        <v-flex xs6
                          ><v-checkbox
                            v-model="productUnit.basicPriceflag"
                            @change="
                              basicPriceflagChange(
                                index,
                                productUnit.basicPriceflag
                              ),
                                copyBasicPricePercent(
                                  index,
                                  productUnit.basicPriceflag
                                )
                            "
                          ></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs2>
                      <v-text-field
                        v-model="productUnit.barcode"
                        :rules="rules.barcodeRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                      <v-text-field
                        name="Unit Cost"
                        v-model="productUnit.unitCost"
                        min="0"
                        :rules="rules.unitCostRules"
                        step="0.01"
                        @input="
                          applyBasicPriceCalculation(
                            index,
                            productUnit.basicPriceflag
                          )
                        "
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2>
                      <v-text-field
                        name="Unit Cost%"
                        v-model="productUnit.unitCostPercentage"
                        min="0"
                        @input="
                          copyBasicPricePercent(
                            index,
                            productUnit.basicPriceflag
                          )
                        "
                        :rules="rules.unitCostPercentageRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1 v-if="productUnit.factor !== 1">
                      <v-btn
                        icon
                        @click="removeProductUnit(index, productUnit.id)"
                      >
                        <v-icon>cancel</v-icon>
                      </v-btn>
                    </v-flex>
                    <v-flex xs1 v-else>
                      <v-btn
                        icon
                        @click="removeProductUnit(index, productUnit.id)"
                        disabled
                      >
                        <v-icon>cancel</v-icon>
                      </v-btn>
                    </v-flex>
                  </v-layout>

                  <v-layout row wrap class="light--text ml-2">
                    <v-flex xs11>
                      <v-layout row>
                        <v-flex xs3>Selling Price</v-flex>
                        <v-flex xs3>Selling Price(%)</v-flex>
                        <v-flex xs3>WholeSale Selling Price</v-flex>
                        <v-flex xs3>WholeSale Selling Price(%)</v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                  <v-layout row class="ml-2">
                    <v-flex xs11>
                      <v-layout row>
                        <v-flex xs3>
                          <v-text-field
                            v-model="productUnit.sellingPrice"
                            min="0"
                            @input="
                              applyBasicPriceCalculation(
                                index,
                                productUnit.basicPriceflag
                              )
                            "
                            :rules="rules.sellingPriceRules"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs3>
                          <v-text-field
                            name="ws Selling Price%"
                            v-model="productUnit.sellingPricePercentage"
                            min="0"
                            @input="
                              copyBasicPricePercent(
                                index,
                                productUnit.basicPriceflag
                              )
                            "
                            :rules="rules.sellingPricePercentageRules"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs3>
                          <v-text-field
                            v-model="productUnit.wholeSaleSellingPrice"
                            min="0"
                            @input="
                              applyBasicPriceCalculation(
                                index,
                                productUnit.basicPriceflag
                              )
                            "
                            :rules="rules.sellingPriceRules"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs3>
                          <v-text-field
                            name="ws Selling Price%"
                            v-model="
                              productUnit.wholeSaleSellingPricePercentage
                            "
                            min="0"
                            @input="
                              copyBasicPricePercent(
                                index,
                                productUnit.basicPriceflag
                              )
                            "
                            :rules="rules.sellingPricePercentageRules"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
              <v-flex v-if="product.productType === 'PRODUCTION'">
                <v-layout row wrap>
                  <v-flex xs2>
                    <v-btn color="success" @click="showProduct()">
                      {{ "Add Item" }}
                      <v-icon right>add</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  class="light--text"
                  v-if="
                    !!product.productItems && product.productItems.length > 0
                  "
                >
                  <v-flex xs3>{{ "Code" }}</v-flex>
                  <v-flex xs3>{{ "Name" }}</v-flex>
                  <v-flex xs3>{{ "Unit" }}</v-flex>
                  <v-flex xs2>{{ "Qty" }}</v-flex>
                  <v-flex xs1>{{ "Action" }}</v-flex>
                </v-layout>
                <v-layout
                  row
                  wrap
                  v-for="(productItem, i) in product.productItems"
                  :key="i"
                >
                  <v-flex xs3>
                    <v-text-field
                      v-model="productItem.itemProductCode"
                      type="text"
                      :rules="rules.codeRules"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-text-field
                      v-model="productItem.itemProductName"
                      type="text"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs3>
                    <v-autocomplete
                      v-model="productItem.factorUnitName"
                      :hide-no-data="true"
                      :items="productItem.productUnits"
                      item-value="factorUnitName"
                      item-text="factorUnitName"
                      v-bind:placeholder="'Unit'"
                      @change="(option) => changeUnit(option, i)"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs2>
                    <v-text-field
                      v-model="productItem.itemProductQty"
                      type="number"
                      :rules="rules.geraterThanZeroQtyRules('Qty')"
                    ></v-text-field>
                  </v-flex>  
                  <v-flex xs1>
                    <v-btn icon @click="removeProductItem(i, productItem.id)">
                      <v-icon>cancel</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="!valid"
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                v-bind:label="'Code'"
                type="text"
                class="mr-1"
                v-model="productQueryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                v-bind:label="'Name'"
                type="text"
                class="mr-1"
                v-model="productQueryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                v-bind:label="'Brand'"
                type="text"
                class="mr-1"
                v-model="productQueryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                v-bind:label="'Category'"
                type="text"
                class="mr-1"
                v-model="productQueryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearchProduct">
                {{ "Search" }}
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="productheaders"
                :items="productList"
                class="elevation-1"
                :loading="showListLoading"
                v-model="selectedProductList"
                :total-items="productTotalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="productpagination"
                :must-sort="true"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th></th>
                    <th v-for="header in props.headers" :key="header.text">
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <td>
                    <v-checkbox
                      primary
                      hide-details
                      :input-value="props.selected"
                      :value="props.item"
                      :indeterminate="props.indeterminate"
                      v-model="selectedProductList"
                      multiple
                      :disabled="
                        !!product.productItems &&
                        !!product.productItems.find(
                          (v) => v.itemProductCode == props.item.code
                        )
                      "
                    ></v-checkbox>
                  </td>
                  <td>
                    {{ props.item.code }}
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brandName }}</td>
                  <td>{{ props.item.categoryName }}</td>
                  <td>{{ props.item.productType }}</td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
              <div class="text-xs-right">
                <v-btn color="primary" @click="setProduct"> Ok </v-btn>
              </div>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- error message dialog -->
    <v-dialog
      v-model="errorMessageBox"
      max-width="500px"
      @keydown.enter="closeErrMsgBox"
      @keydown.esc="closeErrMsgBox"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="warning" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="closeErrMsgBox"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end error message dialog -->
  </v-container>
</template>

<script>
import { productService } from "../../services/product-service";
import { brandService } from "../../services/brand-service";
import { categoryService } from "../../services/category-service";
import { productGroupService } from "../../services/product-group-service";
import { unitService } from "../../services/unit-service";
import { Product } from "../../models/model";
import { ProductUnit } from "../../models/model";
import { ProductItem } from "../../models/model";
import { commonService } from "../../services/common-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { ProductFormRules } from "../../helpers/validation-rules";
export default {
  name: "ProductDetail",
  components: { VSwitch },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    breadcrumbs: [
      {
        text: "Product",
        disabled: false,
        to: "products",
      },
      {
        text: "Product Detail",
        disabled: true,
      },
    ],
    productheaders: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "b.name" },
      { text: "Category", value: "c.name" },
      { text: "Product Type", value: "productType" },
      { text: "Description", value: "description" },
    ],
    createdDate: "",
    updatedDate: "",
    product: new Product(),
    oldProduct: new Product(),
    productUnit: new ProductUnit(),
    productItem: new ProductItem(),
    statusFlag: true,
    saveLoading: false,
    showProductListDialog: false,
    showListLoading: false,
    responseError: "",
    rules: new ProductFormRules(),
    brandList: [],
    productQueryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productType: "",
    },
    productpagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    productTypeList: [
      { label: "STANDARD", value: "STANDARD" },
      { label: "PRODUCTION", value: "PRODUCTION" },
    ],
    categoryList: [],
    productGroupList: [],
    selectedProductList: [],
    activeUnitList: [],
    unitListByProduct: [],
    productList: [],
    tempList: [],
    errorMessageBox: false,
    productTotalRows: 0,
    rowsPerPageItems: [25, 50, 100],
  }),
  created() {
    this.getBrands();
    this.getCategories();
    this.getProductGroups();
    this.getActiveUnits();

    const id = this.$route.params.id;
    if (id == "new") {
      // new product
      this.initProductUnit();
    } else {
      this.getProductDetail(id);
    }
  },
  watch: {
    productpagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
  },
  methods: {
    getBrands() {
      brandService
        .getBrandsByStatus("ACTIVE")
        .then((res) => {
          this.brandList = res.data;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getCategories() {
      categoryService
        .getCategoriesByStatus("ACTIVE")
        .then((res) => {
          this.categoryList = res.data;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    getProductGroups() {
      productGroupService
        .getProductGroupsByStatus("ACTIVE")
        .then((res) => {
          this.productGroupList = res.data;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },
    removeImage() {
      this.product.imageUrl = null;
    },
    getAllUnits() {
      var temp;
      var tempUnitList = [];
      for (var i = 0; i < this.unitListByProduct.length; i++) {
        temp = this.unitListByProduct[i].name;
        if (!this.tempList.includes(temp)) {
          this.tempList.push(temp);
          tempUnitList.push(this.unitListByProduct[i]);
        }
      }

      for (var j = 0; j < this.activeUnitList.length; j++) {
        temp = this.activeUnitList[j].name;
        if (!this.tempList.includes(temp)) {
          this.tempList.push(temp);
          tempUnitList.push(this.activeUnitList[j]);
        }
      }
      this.activeUnitList = tempUnitList;
    },

    getActiveUnits() {
      unitService
        .getUnitsByStatus("ACTIVE")
        .then((res) => {
          this.activeUnitList = res.data;
        })
        .catch((err) => {
          console.log(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },

    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;
        this.product.status = this.statusFlag ? "ACTIVE" : "INACTIVE";
        var str = this.product.code;
        var code = str.replace(/\s/g, "");
        this.product.code = code;
        productService
          .saveProduct(this.product)
          .then((res) => {
            console.log(res);
            this.goBack();
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.errorMessageBox = true;
            }
            this.saveLoading = false;
          });
      }
    },

    getProductDetail(id) {
      productService
        .getProductDetail(id)
        .then((res) => {
          this.product = res.data;
          if (!this.product.name2) this.product.name2 = "";
          this.categoryList.push(res.data.category);
          this.productGroupList.push(res.data.productGroup);
          this.brandList.push(res.data.brand);
          let tList = res.data.productUnits;
          for (let temp of tList) {
            this.unitListByProduct.push(temp.unit);
          }
          this.getAllUnits();
          this.createdDate = commonService.formatDate(
            new Date(this.product.createdDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          this.updatedDate = commonService.formatDate(
            new Date(this.product.updatedDateInMilliSeconds)
              .toISOString()
              .substr(0, 10),
            "YYYY-MM-DD"
          );
          // deep copy
          this.oldProduct = JSON.parse(JSON.stringify(res.data));
          this.statusFlag = this.product.status == "ACTIVE" ? true : false;
          // if (res.data.productItems) {
          //   this.selectedProductList = res.data.productItems.map((v) => {
          //     return v.itemProduct;
          //   });
          //   console.log(">>>>>", this.selectedProductList);
          // }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    clear() {
      this.$refs.form.resetValidation();
      if (!this.product.id) {
        this.product = new Product();
        this.statusFlag = true;
        this.initProductUnit();
      } else {
        this.product = this.oldProduct;
        this.statusFlag = this.product.status == "ACTIVE" ? true : false;
      }
    },
    goBack() {
      this.$router.push("/products");
    },

    initProductUnit() {
      // deep copy
      let pu = JSON.parse(JSON.stringify(this.productUnit));
      pu.factor = 1;
      pu.basicUnit = true;
      this.product.productUnits.push(pu);
    },
    addProductUnit() {
      // deep copy
      let pu = JSON.parse(JSON.stringify(this.productUnit));
      this.product.productUnits.push(pu);
    },
    addProductItem() {
      // deep copy
      let pu = JSON.parse(JSON.stringify(this.productItem));
      this.product.productItems.push(pu);
    },
    removeProductUnit(index, productUnitId) {
      if (productUnitId) {
        // add delete product unit id
        if (!this.product.deleteProductUnitIds) {
          this.product.deleteProductUnitIds = [];
        }
        this.product.deleteProductUnitIds.push(productUnitId);
      }
      this.$delete(this.product.productUnits, index);
    },
    basicPriceflagChange(index, basicPriceflag) {
      for (var i = 0; i < this.product.productUnits.length; i++) {
        if (i != index) this.product.productUnits[i].basicPriceflag = false;
      }
      this.applyBasicPriceCalculation(index, basicPriceflag);
    },
    applyBasicPriceCalculation(index, basicPriceflag) {
      if (basicPriceflag) {
        let oneUnitCost =
          this.product.productUnits[index].unitCost /
          this.product.productUnits[index].factor;
        let oneSellingPrice =
          this.product.productUnits[index].sellingPrice /
          this.product.productUnits[index].factor;
        let oneWsSellingPrice =
          this.product.productUnits[index].wholeSaleSellingPrice /
          this.product.productUnits[index].factor;
        for (var i = 0; i < this.product.productUnits.length; i++) {
          if (i != index) {
            this.product.productUnits[i].unitCost = parseFloat(
              (oneUnitCost * this.product.productUnits[i].factor).toFixed(6)
            );
            this.product.productUnits[i].sellingPrice = parseFloat(
              (oneSellingPrice * this.product.productUnits[i].factor).toFixed(6)
            );
            this.product.productUnits[i].wholeSaleSellingPrice = parseFloat(
              (oneWsSellingPrice * this.product.productUnits[i].factor).toFixed(
                6
              )
            );
          }
        }
      }
    },
    copyBasicPricePercent(index, basicPriceflag) {
      if (basicPriceflag) {
        let ucpercent = this.product.productUnits[index].unitCostPercentage;
        let sppercent = this.product.productUnits[index].sellingPricePercentage;
        let wspercent =
          this.product.productUnits[index].wholeSaleSellingPricePercentage;
        for (var i = 0; i < this.product.productUnits.length; i++) {
          if (i != index) {
            this.product.productUnits[i].unitCostPercentage = ucpercent;
            this.product.productUnits[i].sellingPricePercentage = sppercent;
            this.product.productUnits[i].wholeSaleSellingPricePercentage =
              wspercent;
          }
        }
      }
    },
    onFileChanged(event) {
      const file = event.target.files[0];
      this.product.imageUrl = URL.createObjectURL(file); // to show preview image
      commonService.getBase64(file).then((data) => {
        this.product.image = data;
      });
    },
    closeErrMsgBox() {
      this.errorMessageBox = false;
      this.responseError = "";
    },
    changeUnit(factorUnitName, index) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.product.productItems[index].productUnits
      );
      this.product.productItems[index].itemProductUnitId = productUnit.id;
    },
    showProduct() {
      this.productList = [];
      // Clean query params
      this.productQueryParams.code = "";
      this.productQueryParams.name = "";
      this.productQueryParams.brandName = "";
      this.productQueryParams.categoryName = "";
      this.productQueryParams.productType = "STANDARD";
      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },
    getProductList() {
      this.productList = [];
      this.showListLoading = true;
      let order = this.productpagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.productQueryParams,
          this.productpagination.page,
          this.productpagination.rowsPerPage,
          this.productpagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.productTotalRows = res.data.totalElements;
            this.checkSelected(this.productList);
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    removeProductItem(index, productItemId) {
      console.log("index", index);
      console.log("id", productItemId);
      if (productItemId) {
        if (!this.product.deleteProductItemIds) {
          this.product.deleteProductItemIds = [];
        }
        this.product.deleteProductItemIds.push(productItemId);
      }
      console.log("iems>", this.product.productItems);
      this.$delete(this.product.productItems, index);
    },
    setProduct() {
      this.showProductListDialog = false;
      let filterList = [];
      if (this.product.productItems) {
        filterList = this.selectedProductList
          .filter((v) => typeof v != "undefined")
          .filter(
            (x) =>
              !this.product.productItems.find(
                (z) => z.itemProductCode == x.code
              )
          );
      } else {
        filterList = this.selectedProductList;
        this.product.productItems = [];
      }
      this.product.productItems.push(
        ...filterList.map((product) => ({
          itemProduct: product,
          itemProductCode: product.code,
          itemProductName: product.name,
          itemProductQty: 0,
          itemProductId: product.id,
          productUnits: product.productUnits,
          factorUnitName: product.productUnits.find((v) => v.basicUnit == true)
            .factorUnitName,
          itemProductUnitId: product.productUnits.find(
            (v) => v.basicUnit == true
          ).id,
        }))
      );
    },
    onSearchProduct() {
      this.productQueryParams.productType = "STANDARD";
      this.productQueryParams.page = this.productpagination.page;
      this.productQueryParams.size = this.productpagination.rowsPerPage;
      this.getProductList();
    },
    checkSelected(productList) {
      if (this.product.productItems.length > 0) {
        this.selectedProductList = [];
        this.product.productItems.forEach((element) => {
          this.selectedProductList.push(
            commonService.search("code", element.itemProductCode, productList)
          );
        });
        console.log(">>>", this.selectedProductList);
      } else {
        this.selectedProductList = [];
      }
    },
  },
};
</script>
